import axios from "../plugins/parseAxios";
export class QRPaymentAPI {

  static qrPaymentRequest(postData) {
    return axios.post("functions/qrPaymentRequest", postData);
  }

  static qrPaymentCheckStatus(id) {
    return axios.post("functions/qrPaymentCheckStatus", { id });
  }

  static qrPaymentInquiry(id) {
    return axios.post("functions/qrPaymentInquiry", { id });
  }

  static qrPaymentLastRequest(postData) {
    return axios.post("functions/qrPaymentLastRequest", postData);
  }

  static qrPaymentCancel(id) {
    return axios.post("functions/qrPaymentCancel", { id });
  }

  static qrPaymentVoid(postData) {
    return axios.post("functions/qrPaymentVoid", postData);
  }

  static qrPaymentVoidWithCancelPayment(postData) {
    return axios.post("functions/qrPaymentVoidWithCancelPayment", postData);
  }
}
